import React, { Component } from 'react';
import interaction from '../../../../utils/interaction';
import ProgressBar from '../../shared/progress_bar';

class InputComponent extends Component {

  constructor(props){ 
    super(props);
    this.state = {
      selectedAnswer: ""
    }

    this.pushSelectedAnswer = this.pushSelectedAnswer.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);
  }
  
  componentDidMount() {
    interaction.handleTextareaLimiter(document.querySelector(".text-input__textarea"));
  }

  updateInputValue(event) {
    this.setState({
      selectedAnswer: event.target.value
    });
  }

  pushSelectedAnswer() {
    this.props.next(this.state.selectedAnswer)
  }

  render() {
    const { translation } = this.props;
    return (
        <div className="page__container js-select-form">
            <div className="page__top-wrapper">
                <div className="page__text">
                    <h1>{this.props.actualQuestion.title}</h1>
                    <p className="page__desc">{this.props.actualQuestion?.description}</p>
                </div>
                <ProgressBar questions={this.props.questions} actualQuestion={this.props.actualQuestion} type="dark"/>
            </div>

            {this.props.actualQuestion.image.length > 0 &&  <img className="text-input__img" src={this.props.actualQuestion.image} alt="Producto"></img>}

            <textarea
                value={this.state.selectedAnswer}
                onChange={this.updateInputValue}
                className="text-input__textarea" 
                name="textarea" 
                rows="10"
                maxLength="200"
                placeholder="Escríbe tu respuesta...">
            </textarea>

            <footer className="text-input__footer">
                <em className="text-input__alert-message js-textarea-alert" hidden>{translation('EXCEDE_CHARACTERS')}.</em>
                <span className="text-input__counter" aria-hidden="true">
                    <span className="js-textarea-counter">0</span>/<span className="js-textarea-max-length"></span>
                </span>
            </footer>

            <button 
              onClick={this.pushSelectedAnswer}
              className="text-input__main-button main-button main-button--colored js-select-submit-button" 
              type="submit">
                <span className="main-button__label">Continuar</span>
                <svg className="main-button__icon" width="25" height="25">
                    <use xlinkHref="/images/sprite.svg#arrow_down"></use>
                </svg>
            </button>
        </div>
    );
  }

}

export default InputComponent;
